import {Layout} from "antd";
import {useState} from "react";
import './layout.css'

const { Sider } = Layout;



export default function BaseLayout({children})
{
    const [open, setOpen] = useState(false);

    return (
        <div>
            <Layout style={{
                backgroundColor: '#e6eef2',
            }}>
                {children}
            </Layout>
        </div>
    )
}
